'use strict';module.exports="production"===process.env.NODE_ENV?require("./umd/history.production.min.js"):require("./umd/history.development.js")
